// Calculates Progress for each document
const getProgressForDocument = (
  absolutePaths,
  downloadedBookPaths,
  isBookDownloadedForMobileApp,
) => {
  // If book is downloaded mobile app, document progress is complete.
  if (isBookDownloadedForMobileApp) {
    return {
      absolutePaths,
      downloadedAbsolutePaths: absolutePaths,
      isComplete: true,
      percentage: 1,
      percentageDisplay: 100,
    };
  }

  let downloadedAbsolutePaths = [];
  for (let absolutePath of absolutePaths) {
    if (downloadedBookPaths.has(absolutePath)) {
      downloadedAbsolutePaths.push(absolutePath);
    }
  }

  let percentage = absolutePaths.length
    ? downloadedAbsolutePaths.length / absolutePaths.length
    : 1;

  const progressForDocument = {
    absolutePaths,
    downloadedAbsolutePaths,
    isComplete: downloadedAbsolutePaths.length === absolutePaths.length,
    percentage,
    percentageDisplay: Math.round(percentage * 10000) / 100,
  };

  return progressForDocument;
};

/**
 * Calculates Documents download progress
 *
 * @method getDocumentsProgress
 * @param {Map} documentsProgress - previous map of documents to objects with progress information
 * @param {Object} persistedOfflineSession - persisted offline session object
 * @param {Set} downloadedBookPaths - set of all downloaded paths for the book
 * @param {Boolean} isBookDownloadedForMobileApp - is book downloaded for mobile App or not
 * @returns {Map} map of documents to objects with progress information
 */
const getDocumentsProgress = (
  documentsProgress = new Map(),
  persistedOfflineSession,
  downloadedBookPaths = new Set(),
  isBookDownloadedForMobileApp = false,
) => {
  const { absolutePathsByDocument } = persistedOfflineSession; // list of paths for each document in offline session
  const documentsPreviouslyDownloaded = [...documentsProgress.keys()]; // list of documents in last calculated documentProgress

  for (const [document, absolutePaths] of absolutePathsByDocument.entries()) {
    // If absolutePathsByDocument contains the document, it still exists in current offline Session
    documentsPreviouslyDownloaded.splice(
      documentsPreviouslyDownloaded.indexOf(document),
      1,
    );

    // Dont need to recalculate progress for documents that are already complete
    if (documentsProgress.get(document)?.isComplete) {
      continue;
    }

    documentsProgress.set(
      document,
      getProgressForDocument(
        absolutePaths,
        downloadedBookPaths,
        isBookDownloadedForMobileApp,
      ),
    );
  }

  // Progress for Documents not in offline session, can be removed.
  for (const document of documentsPreviouslyDownloaded) {
    documentsProgress.delete(document);
  }
  return documentsProgress;
};

export default getDocumentsProgress;
